import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const WHATSAPP_NUMBER = "34610935531";

export const qtyDiscountFactor = (qty) => (qty >= 50 ? 0.5 : qty >= 10 ? 0.75 : 1);

export const formatPrice = (n) => `${n.toFixed(2).replace(".", ",")}€`;

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const imageUrl = (path) => (path ? `${API}/images/${path}` : null);

export const productImages = (p) => {
  const list = Array.isArray(p?.image_paths) ? [...p.image_paths] : [];
  if (p?.image_path && !list.includes(p.image_path)) list.unshift(p.image_path);
  return list;
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo ha fallado. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
